import { useMediaQuery, useTheme } from "@mui/material";
import { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const NavigationContext = createContext();

const NavigationProvider = ({ children }) => {
  const theme = useTheme();

  // Records the current path / feature selected
  const [currentPath, setCurrentPath] = useState("/");
  const [currentFeature, setCurrentFeature] = useState("");
  const [isSelected, setIsSelected] = useState({
    ai: false,
    course: false,
    game: false,
    home: false,
    learn: false,
    projection: false,
  });

  // Determines if navigation interface is shown
  const [showNav, setShowNav] = useState(false);
  // Determines whether to include top navigation interface (appbar)
  const isMobileNav = useMediaQuery(theme.breakpoints.only("xs"));

  // Encapsulates default React navigation
  const navigateTo = useNavigate();
  const navigate = (path) => navigateTo(path);

  // Checks which feature is selected
  useEffect(() => {
    const newIsSelected = Object.fromEntries(
      Object.entries(isSelected).map(([feature, _]) => [feature, false])
    );
    newIsSelected[currentFeature] = true;
    setIsSelected(newIsSelected);
  }, [currentPath, currentFeature]);

  // Checks whether the navigation bars should be displayed
  useEffect(() => {
    setShowNav(
      currentFeature !== "login" &&
      currentFeature !== "signup" &&
      currentFeature !== "signout" &&
      currentFeature !== "privacy-policy" &&
      currentFeature !== "questionnaire"
    );
  }, [currentPath, currentFeature]);

  const contextValue = {
    currentFeature,
    currentPath,
    isMobileNav,
    isSelected,
    navigate,
    setCurrentFeature,
    setCurrentPath,
    setShowNav,
    showNav,
  };

  return (
    <NavigationContext.Provider value={contextValue}>
      {children}
    </NavigationContext.Provider>
  );
};

export default NavigationContext;
export { NavigationProvider };
